<template>
  <div id="container">
    <div class="product-status">
      <div class="bold"></div>
      <div style="position: absolute;top:10px;right:20px;z-index: 99">
        <div>
          <el-checkbox v-model="checked" style="padding-left:16px;" @change="hide">隐藏账户余额为0的账户</el-checkbox>
        </div>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          :label="item.title"
          :name="item.name"
          class="tab-text"
          v-for="(item,index) in balanceList"
          :key="index"
        ></el-tab-pane>
      </el-tabs>
      <finance-seach
        ref="financeSeachRefs"
        :column-option="columnList"
        :expression-array="['accountBalance', 'deductionAmount']"
        @onSearch="onSearch"
      ></finance-seach>
      <div>
        <div class="box-table" :style="{height: $store.state.Sell.height+'px'}">
          <el-row style="margin-bottom:14px">
            <el-col :span="8" v-if="activeName==='2'">
              <div class="title-font">
                <div class="boldi"></div>
                <span @click="tabTop" :class="active===1?'active':''" style="margin-left: 26px">账户余额</span>
                <span
                  @click="tabBottom"
                  :class="active===2?'active':''"
                  style="margin-left: 40px"
                >抵扣金额</span>
              </div>
            </el-col>
            <el-col :span="16" :style="activeName==='1'?'text-align:left': 'text-align:right'">
              <span>
                查询结果共：
                <span style="color:#D35E5E;">{{total}}</span>条
              </span>
              <span style="margin:0 50px">
                账户总金额：
                <span
                  style="color:#D35E5E;"
                >{{queryParams.sumAccountBalance | priceFilterNum }}</span>元
              </span>
              <span>
                可用总金额：
                <span style="color:#D35E5E;">{{queryParams.sumUseBalance | priceFilterNum}}</span>元
              </span>
            </el-col>
          </el-row>
          <el-table
            border
            ref="tableRef"
            :data="list"
            :max-height="$store.state.Sell.height-40"
            tooltip-effect="dark"
            :header-cell-style="tableHeader"
            v-loading="loadingTable"
            element-loading-text="拼命加载中请稍后..."
            element-loading-spinner="el-icon-loading"
          >
            <el-table-column
              :label="activeName === '1'?'客户名称':'供应商名称'"
              min-width="120"
              show-overflow-tooltip
              key="1"
            >
              <template slot-scope="scope">
                <span @click="onCusName(scope.row)" class="approval">{{scope.row.cusName}}</span>
              </template>
            </el-table-column>
            <el-table-column label="账户余额" v-if="active === 1||activeName === '1'" key="2">
              <template slot-scope="scope">{{ scope.row.accountBalance | priceFilterNum }}</template>
            </el-table-column>
            <el-table-column label="抵扣金额" v-if="active === 2&&activeName === '2'" key="3">
              <template slot-scope="scope">{{ scope.row.deductionAmount | priceFilterNum }}</template>
            </el-table-column>
            <el-table-column label="可用余额" v-if="active === 1||activeName === '1'" key="4">
              <template slot-scope="scope">{{ scope.row.useBalance | priceFilterNum }}</template>
            </el-table-column>
            <el-table-column label="可用抵扣金额" v-if="active === 2&&activeName === '2'" key="5">
              <template slot-scope="scope">{{ scope.row.useDeduction | priceFilterNum }}</template>
            </el-table-column>
            <el-table-column label="当前负责人" v-if="activeName === '1'" key="6">
              <template slot-scope="scope">{{scope.row.staffCnName||'--'}}</template>
            </el-table-column>
            <el-table-column label="委托人" v-if="activeName === '1'" key="7">
              <template slot-scope="scope">{{scope.row.clientName||'--'}}</template>
            </el-table-column>
            <el-table-column label="收支记录" key="8">
              <template slot-scope="scope">
                <el-button type="text" plain @click="look(scope.row)">查看</el-button>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" key="9">
              <template slot-scope="scope">
                <el-button type="text" @click="onInfo(scope.row)">调整金额</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination">
          <pagination
            :total="total"
            :pageSize="pageSize"
            :currentPage="currentPage"
            @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
          ></pagination>
        </div>
      </div>
    </div>
    <!-- 弹框 -->
    <el-dialog title="调整金额" :visible.sync="dialogVisible" width="557px">
      <el-form :model="formObj" style="padding: 0 30px" label-width="85px">
        <el-form-item label="类型：" v-if="activeName === '1'">
          <el-select v-model="formObj.balanceType">
            <el-option label="不可提现余额" value="1"></el-option>
            <el-option label="可提现" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="调整金额：" :rules="filter_rules({required:true})">
          <el-input v-model.number="formObj.newValue" type="number" placeholder="增减余额用±表示"></el-input>
        </el-form-item>
        <el-form-item
          label="备注原因："
          :rules="filter_rules({required:true})"
          style="margin-bottom:14px"
        >
          <el-input type="textarea" :rows="3" v-model="formObj.exPlain" placeholder="备注信息不可为空"></el-input>
        </el-form-item>
        <span class="upon">提交上级审批，通过后生效，生成收支记录</span>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onSubmit" :disabled='disabled'>确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import pagination from '@/components/pagination'
import {
  balanceList,
  balanceMList,
  payMList,
  givetabs
} from '../financeManage/util/data'
import {
  queryCustomerByFinance,
  querySupplierByFinance,
  moneyadd,
  supplierBalanceApproval
} from '@/api/fiance/fianceManage'
import financeSeach from '@/components/module/financeSeach'
export default {
  components: {
    pagination,
    financeSeach
  },
  data () {
    return {
      disabled: false,
      columnArr: [],
      columnList: balanceMList,
      queryParams: {},
      balanceList, // tabs状态
      activeName: '1', // 1 客户  2 供应商
      active: 1, // 1 余额  2 抵扣金额
      list: [], // 列表数据
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      total: 0, // 列表总数
      loadingTable: false, // 列表loading
      checked: false,
      dialogVisible: false, // 调整金额
      formObj: {} // 弹框对象
    }
  },
  mounted () {
    this.activeName = '1'
    this.getList()
    // if (this.activeName === '2') {
    //   this.$refs.paneparents[0].$parent.$parent.$el.childNodes[0].firstChild.style.display =
    //     'none'
    // }
  },
  methods: {
    onCusName (row) {
      const src = this.activeName === '1' ? 'customer/details' : 'supplierEdit'
      this.$router.push({ name: src, query: { id: row.cusId } })
    },
    hide () {
      this.getList()
    },
    tabTop () {
      this.columnList = givetabs
      this.active = 1
      this.$refs.financeSeachRefs.searchReset()
    },
    tabBottom () {
      this.columnList = payMList
      this.active = 2
      this.$refs.financeSeachRefs.searchReset()
    },
    onSearch (arr) {
      this.pageSize = 30
      this.currentPage = 1
      this.columnArr = arr
      this.getList()
    },
    // 调整金额
    onInfo (row) {
      this.formObj = row
      this.formObj.cbId = row.cusId
      delete this.formObj.newValue
      delete this.formObj.exPlain
      if (this.activeName === '1') {
        this.$set(this.formObj, 'balanceType', '1')
      }
      this.disabled = false
      this.dialogVisible = true
    },
    onSubmit () {
      this.disabled = true
      if (!this.formObj.newValue || !this.formObj.exPlain) {
        this.$message.error('必填项不得为空！')
        this.disabled = false
        return
      }
      const num = function (num) {
        return num ? '-' + parseFloat(num).toFixed(2) : '0.00'
      }
      if (this.activeName === '1') {
        if (this.formObj.balanceType === '1') {
          if (+this.formObj.notWithdrawCash + +this.formObj.newValue < 0) {
            const str = num(this.formObj.notWithdrawCash)
            this.$message.error(`调整金额不可小于${str}！`)
            this.disabled = false
            return
          }
        } else {
          if (+this.formObj.withdrawCash + +this.formObj.newValue < 0) {
            const str = num(this.formObj.withdrawCash)
            this.$message.error(`调整金额不可小于${str}！`)
            this.disabled = false
            return
          }
        }
        moneyadd(this.formObj).then((res) => {
          if (res.data.code === 200) {
            this.$message.success(res.data.msg)
            this.dialogVisible = false
          } else {
            this.$message.error(res.data.msg)
          }
        })
      } else {
        if (this.active === 1) {
          if (+this.formObj.accountBalance + +this.formObj.newValue <= 0) {
            const str = num(this.formObj.accountBalance)
            this.$message.error(`调整金额不可小于${str}！`)
            this.disabled = false
            return
          }
        } else if (this.active === 2) {
          if (+this.formObj.deductionAmount + +this.formObj.newValue <= 0) {
            const str = num(this.formObj.deductionAmount)
            this.$message.error(`调整金额不可小于${str}！`)
            this.disabled = false
            return
          }
        }
        this.formObj.type = this.active
        supplierBalanceApproval(this.formObj).then((res) => {
          if (res.data.code === 200) {
            this.$message.success(res.data.msg)
            this.dialogVisible = false
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }
    },
    look (row) {
      // 查看
      this.$router.push({
        name: 'notes',
        query: { id: row.cusId, name: this.activeName, type: this.active }
      })
    },
    // tabs切换时触发的事件
    handleClick () {
      this.currentPage = 1
      this.$refs.financeSeachRefs.searchReset()
      if (this.activeName === '2') {
        this.columnList = givetabs
        this.active = 1
      } else {
        this.columnList = balanceMList
      }
      this.getList()
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 列表数据
    getList () {
      this.loadingTable = true
      this.list = []
      const params = {
        criteriaVoList: JSON.parse(JSON.stringify(this.columnArr)),
        queryPageName: ''
      }
      if (this.checked) {
        params.criteriaVoList.push({ column: 'type', value: 1 })
      }
      if (this.activeName === '1') {
        queryCustomerByFinance(this.currentPage, this.pageSize, params).then(
          (res) => {
            if (res.data.code === 200) {
              this.loadingTable = false
              this.list =
                res.data.obj.records[0].customerFinanceAccountListVoList || []
              this.queryParams = res.data.obj.records[0]
              this.total = res.data.obj.total
            } else {
              this.$message.error(res.data.msg)
            }
          }
        )
      } else {
        querySupplierByFinance(
          this.currentPage,
          this.pageSize,
          this.active,
          params
        ).then((res) => {
          if (res.data.code === 200) {
            this.loadingTable = false
            this.list =
              res.data.obj.records[0].customerFinanceAccountListVoList || []
            this.queryParams = res.data.obj.records[0]
            this.total = res.data.obj.total
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }
    },
    // 页数
    handleSizeChange (val) {
      this.currentPage = 1
      this.pageSize = val
      this.getList()
    },
    // 页码
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    }
  }
}
</script>
<style lang="scss" scoped>
.title-font {
  display: flex;
  font-size: 16px;
  line-height: 16px;
  .boldi {
    display: inline-block;
    background-color: #276cff;
    width: 4px;
    height: 20px;
    margin-top: 2px;
  }
  span {
    padding: 2px 0 6px;
  }
  .active {
    border-bottom: 2px solid #276cff;
    color: #276cff;
  }
}
.balan {
  width: 200px;
  padding-left: 13px;
}
.upon {
  padding-left: 85px;
  color: #d35e5e;
}
</style>
